  <div *ngIf="HtmlData" class="complaince">
    <p class="heading">Government compliance</p>
    <div [innerHTML]="HtmlData"></div>
  </div>

<!-- <div *ngIf="loader" class="nodata">Loading....</div> -->

<div *ngIf="mainData.length === 0" class="Committees">
  <div class="nodata">No Data found !</div>
</div>
